import React from "react";
import { ADMIN_LABEL } from "../../config/brand";
import { WEEKDAY_NAMES, formatDaysLabelLong } from "../../lib/weekdays";

const SHORT_LABEL = {
  lundi: "Lun",
  mardi: "Mar",
  mercredi: "Mer",
  jeudi: "Jeu",
  vendredi: "Ven",
  samedi: "Sam",
  dimanche: "Dim",
};

export default function WeekdayCheckboxes({
  value = [],
  onChange,
  error,
  idPrefix = "weekday",
  hint,
  legend = "Jours",
}) {
  const selected = new Set(value);
  const hintId = `${idPrefix}-hint`;
  const errorId = `${idPrefix}-error`;
  const previewId = `${idPrefix}-preview`;
  const preview = formatDaysLabelLong(value);
  const describedBy = [
    preview ? previewId : null,
    hint ? hintId : null,
    error ? errorId : null,
  ]
    .filter(Boolean)
    .join(" ") || undefined;

  const toggle = (day) => {
    const next = selected.has(day)
      ? value.filter((item) => item !== day)
      : WEEKDAY_NAMES.filter((name) => selected.has(name) || name === day);
    onChange(next);
  };

  return (
    <fieldset className="space-y-2 min-w-0" aria-describedby={describedBy} aria-invalid={!!error}>
      <legend className={`${ADMIN_LABEL} text-sm font-medium px-0`}>{legend}</legend>
      <div className="flex flex-wrap gap-2">
        {WEEKDAY_NAMES.map((day) => {
          const id = `${idPrefix}-${day}`;
          const checked = selected.has(day);
          return (
            <label
              key={day}
              htmlFor={id}
              className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-sm cursor-pointer ${
                checked
                  ? "border-[rgba(249,115,22,0.5)] bg-[rgba(249,115,22,0.1)] text-[#c47a0a]"
                  : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"
              }`}
            >
              <input
                id={id}
                type="checkbox"
                checked={checked}
                onChange={() => toggle(day)}
                className="rounded border-slate-300 text-[#f97316] focus:ring-[#f97316]"
              />
              <span>{SHORT_LABEL[day]}</span>
            </label>
          );
        })}
      </div>
      <p id={previewId} className={`text-sm ${preview ? "text-slate-700" : "text-slate-400"}`}>
        {preview ? `Aperçu : ${preview}` : "Aucun jour coché."}
      </p>
      {hint ? (
        <div id={hintId} className="text-xs text-slate-500 space-y-1 leading-relaxed">
          {hint}
        </div>
      ) : null}
      {error ? (
        <p id={errorId} className="text-red-600 text-xs" role="alert">
          {error}
        </p>
      ) : null}
    </fieldset>
  );
}
